import { httpsCallable } from 'firebase/functions';
import { functions } from '../../config/firebase';
import {
  ADMIN_PROSPECT_LETTER_TEMPLATES_PAGE_SIZE,
  ADMIN_PROSPECT_LETTER_TEMPLATE_LANGUAGE_V1,
  ADMIN_PROSPECT_LETTER_TEMPLATE_NAME_MAX,
  buildArchiveAdminProspectLetterTemplateRequest,
  buildCreateAdminProspectLetterTemplateRequest,
  buildCreateAdminProspectLetterTemplateRichRequest,
  buildCreateAdminProspectLetterTemplateRichVersionRequest,
  buildCreateAdminProspectLetterTemplateVersionRequest,
  buildDuplicateAdminProspectLetterTemplateRequest,
  buildGetAdminProspectLetterTemplateAssetPreviewUrlRequest,
  buildGetAdminProspectLetterTemplateRequest,
  buildListAdminProspectLetterTemplateVersionsRequest,
  buildListAdminProspectLetterTemplatesRequest,
  buildPreviewAdminProspectLetterTemplatePdfRequest,
  buildTranslateAdminProspectLetterTemplateToEnglishRequest,
  buildUploadAdminProspectLetterTemplateAssetRequest,
  createAdminProspectLetterTemplateWriteAttempt,
  generateAdminProspectLetterTemplateOperationId,
} from './prospectLetterTemplatesRequest.js';

export {
  ADMIN_PROSPECT_LETTER_TEMPLATES_PAGE_SIZE,
  ADMIN_PROSPECT_LETTER_TEMPLATE_LANGUAGE_V1,
  ADMIN_PROSPECT_LETTER_TEMPLATE_NAME_MAX,
  buildArchiveAdminProspectLetterTemplateRequest,
  buildCreateAdminProspectLetterTemplateRequest,
  buildCreateAdminProspectLetterTemplateRichRequest,
  buildCreateAdminProspectLetterTemplateRichVersionRequest,
  buildCreateAdminProspectLetterTemplateVersionRequest,
  buildDuplicateAdminProspectLetterTemplateRequest,
  buildGetAdminProspectLetterTemplateAssetPreviewUrlRequest,
  buildGetAdminProspectLetterTemplateRequest,
  buildListAdminProspectLetterTemplateVersionsRequest,
  buildListAdminProspectLetterTemplatesRequest,
  buildPreviewAdminProspectLetterTemplatePdfRequest,
  buildTranslateAdminProspectLetterTemplateToEnglishRequest,
  buildUploadAdminProspectLetterTemplateAssetRequest,
  createAdminProspectLetterTemplateWriteAttempt,
  generateAdminProspectLetterTemplateOperationId,
};

export async function listActiveAdminProspectLetterTemplates() {
  const active = [];
  let pageToken = null;
  do {
    const data = await listAdminProspectLetterTemplates(
      buildListAdminProspectLetterTemplatesRequest({ pageToken }),
    );
    const rows = Array.isArray(data?.templates) ? data.templates : [];
    for (const row of rows) {
      if (
        row?.status === 'active' &&
        typeof row.templateId === 'string' &&
        Number.isInteger(row.currentVersion)
      ) {
        active.push(row);
      }
    }
    pageToken = data?.nextPageToken || null;
  } while (pageToken);
  return active;
}

export async function createAdminProspectLetterTemplate(payload) {
  const fn = httpsCallable(functions, 'createAdminProspectLetterTemplate');
  const { data } = await fn(payload);
  return data;
}

export async function createAdminProspectLetterTemplateVersion(payload) {
  const fn = httpsCallable(functions, 'createAdminProspectLetterTemplateVersion');
  const { data } = await fn(payload);
  return data;
}

export async function duplicateAdminProspectLetterTemplate(payload) {
  const fn = httpsCallable(functions, 'duplicateAdminProspectLetterTemplate');
  const { data } = await fn(payload);
  return data;
}

export async function archiveAdminProspectLetterTemplate(payload) {
  const fn = httpsCallable(functions, 'archiveAdminProspectLetterTemplate');
  const { data } = await fn(payload);
  return data;
}

export async function listAdminProspectLetterTemplates(request) {
  const fn = httpsCallable(functions, 'listAdminProspectLetterTemplates');
  const { data } = await fn(request);
  return data;
}

export async function getAdminProspectLetterTemplate(request) {
  const fn = httpsCallable(functions, 'getAdminProspectLetterTemplate');
  const { data } = await fn(request);
  return data;
}

export async function listAdminProspectLetterTemplateVersions(request) {
  const fn = httpsCallable(functions, 'listAdminProspectLetterTemplateVersions');
  const { data } = await fn(request);
  return data;
}

export async function uploadAdminProspectLetterTemplateAsset(payload) {
  const fn = httpsCallable(functions, 'uploadAdminProspectLetterTemplateAsset');
  const { data } = await fn(payload);
  return data;
}

export async function getAdminProspectLetterTemplateAssetPreviewUrl(request) {
  const fn = httpsCallable(functions, 'getAdminProspectLetterTemplateAssetPreviewUrl');
  const { data } = await fn(request);
  return data;
}

export async function translateAdminProspectLetterTemplateToEnglish(request) {
  const fn = httpsCallable(functions, 'translateAdminProspectLetterTemplateToEnglish');
  const { data } = await fn(request);
  return data;
}

export async function previewAdminProspectLetterTemplatePdf(request) {
  const fn = httpsCallable(functions, 'previewAdminProspectLetterTemplatePdf');
  const { data } = await fn(request);
  return data;
}
